module.exports = __webpack_public_path__ + "img/icon-jjpt-logo.c3d26c3a.png";